export enum BusinessSettingEnum {
  FormatDateSpanish="DD/MM/YYYY",
  FormatDateEnglish="MM/DD/YYYY",
  CurrencyDollar="$ Dolar",
  CurrencyEuro="€ Euro",
  PrintActionOnlyKitchen="Cocina",
  PrintActionKitchenAndCheck="Cheque y Cocina",
  LastNameFormat="Apellido, Nombre",
  FirstNameFormat="Nombre, Apellido",
  HourFormatAmPm="AM/PM",
  HourFormatMilitary="24 Horas",
  ActionSendAndNew="Enviar y Nuevo",
  ActionSendQuit="Enviar y Quitar",
  DefaultSearchCriterialId="ID #",
  DefaultSearchCriterialPhone="Telefono #",
  DefaultSearchCriterialName="Nombre #",

  CurrencyDollarLabel="$ Dollar",
  CurrencyPesoArgentinoLabel='$ Peso Argentino',
  PrintActionOnlyKitchenLabel="Kitchen",
  PrintActionKitchenAndCheckLabel="Check and Kitchen",
  LastNameFormatLabel="Last Name, First Name",
  FirstNameFormatLabel="First Name, Last Name",
  HourFormatMilitaryLabel="24 Hours",
  ActionSendAndNewLabel="Send and New",
  ActionSendQuitLabel="Send and Quit",
  PrecisionTwoLabel="PRECISION_2",
  PrecisionThreeLabel="PRECISION_3",
  PrecisionEightLabel="PRECISION_8",
  DefaultSearchCriterialPhoneLabel="Phone #",
  DefaultSearchCriterialNameLabel="Name",

  TipPaidOut="Propinas Pagadas",
  TipRetained="Propinas Retenidas",
  GratuityPaidOut="Gratificación Pagada",
  GratuityRetained="Gratificación Retenida",
  DriverCompensationPaidOut="Compensación Pagada",
  DriverCompensationRetained="Compensación Retenida",

  TipPaidOutLabel="Tips Paid Out",
  TipRetainedLabel="Tips Retained",
  GratuityPaidOutLabel="Gratuities Paid Out",
  GratuityRetainedLabel="Gratuities Retained",
  DriverCompensationPaidOutLabel="Compensation Paid Out",
  DriverCompensationRetainedLabel="Compensation Retained",

  TypeDaily="Daily",
  TypeWeekly="Weekly",

  AccountabilityInitial="Inicia la Orden",
  AccountabilityEnd="Finaliza la Orden",
  AccountabilityInitialLabel="Initiates the order",
  AccountabilityEndLabel="Finalizes the order",
  }